import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {LoginService} from '../../core/login/login.service';
import {Router} from '@angular/router';
import {ToastrService} from "ngx-toastr";
import {AccountService} from "../../singelton/account.service";

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
    constructor(private loginService: LoginService, private router:Router, private toastr: ToastrService,public accountService: AccountService) {}

    // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //     return next.handle(request).pipe(
    //         tap(
    //             (event: HttpEvent<any>) => {},
    //             (err: any) => {
    //                 if (err instanceof HttpErrorResponse) {
    //                     if (err.status === 401) {
    //                         this.loginService.logout();
    //                     }
    //                 }
    //             }
    //         )
    //     );
    // }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {},
        (err: any) => {
       //   alert(' inside interceptor ---- <<< >>>>>> ')

      //    if (err instanceof HttpErrorResponse) {
            if (err.status === 401
              && !(err.url && err.url.includes('/api/account'))
              && !(err.url && err.url.includes('/api/authenticate/clear-path'))
              && !(err.url && err.url.includes('/api/authenticate-impersonate'))) {
        //      if(sessionStorage.getItem('isLoggedin')==='true'){
            //   alert(' 401 401 401 401 401 ')
                this.loginService.logout();

        //      }
    //        }
          }
          if(err.status === 403){
            // alert(' in 403 ');
            // this.router.navigate(['/page/mytransaction']);
            if (this.accountService.hasAnyAuthority(['ROLE_CLIENT'])) {

              this.router.navigate(['/page/tickets']).then(() => this.toastr.warning('شما به صفحه درخواستی دسترسی ندارید ', 'ممنوع'));
            } else {
              this.router.navigate(['/page/mytransaction']).then(() => this.toastr.warning('شما به صفحه درخواستی دسترسی ندارید ', 'ممنوع'));

            }
          }
        }
      )
    );
  }
}
